import React from 'react';
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Typography,
} from 'antd';
import { useTranslation } from 'react-i18next';

const pickerStyles = {
  width: '100%',
};

const InfoSection = ({ shoppingCenters, companyCategories, typeInterview }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={9}>
        <Form.Item label={t('Titolo')} name='title'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={15}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label={t('DATA INIZIO SONDAGGIO')} name='date_from'>
              <DatePicker format={'DD MMMM YYYY'} style={pickerStyles} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={t('DATA FINE SONDAGGIO')} name={'date_to'}>
              <DatePicker format={'DD MMMM YYYY'} style={pickerStyles} />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Outlet Village')} name='shopping_center_id'>
          <Select placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {shoppingCenters.map((shoppingCenter) => (
              <Select.Option key={shoppingCenter.id} value={shoppingCenter.id}>
                {shoppingCenter.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('DESTINATARI')} name='type_interview'>
          <Select placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            <Select.Option value='type_interview_company'>
              {t('INSEGNE')}
            </Select.Option>
            <Select.Option value='type_interview_clients'>
              {t('Clienti')}
            </Select.Option>
          </Select>
        </Form.Item>
      </Col>
      {typeInterview === 'type_interview_company' && (
        <>
          <Col span={9}>
            <Form.Item
              label={t(
                'SELEZIONA LE CATEGORIE STORES A CUI APRIRE IL SONDAGGIO',
              )}
              name='company_category_question_ids'
            >
              <Checkbox.Group>
                <Row>
                  {companyCategories.map((companyCategory) => (
                    <Col span={8} key={companyCategory.value}>
                      <Checkbox value={companyCategory.value}>
                        {companyCategory.title}
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            </Form.Item>
            <Form.Item valuePropName='checked' name='in_telegram'>
              <Checkbox>{t('Pubblicazione su Telegram')}</Checkbox>
            </Form.Item>
          </Col>
        </>
      )}
      <Col offset={typeInterview === 'type_interview_company' ? 0 : 9} span={9}>
        <Form.Item
          label={t('SELEZIONE CATEGORIE STORES SU CUI EFFETTUARE IL SONDAGGIO')}
          name='company_category_answer_ids'
        >
          <Checkbox.Group>
            <Row>
              {companyCategories.map((companyCategory) => (
                <Col span={8} key={companyCategory.value}>
                  <Checkbox value={companyCategory.value}>
                    {companyCategory.title}
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
